/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_Stats_CoastingInputs */

const en_ui_more_stats_coasting = /** @type {(inputs: Ui_More_Stats_CoastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coasting`)
};

const de_ui_more_stats_coasting = /** @type {(inputs: Ui_More_Stats_CoastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rollen`)
};

/**
* | output |
* | --- |
* | "Coasting" |
*
* @param {Ui_More_Stats_CoastingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_coasting = /** @type {((inputs?: Ui_More_Stats_CoastingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_CoastingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_coasting(inputs)
	return de_ui_more_stats_coasting(inputs)
});